"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  ScreenOrientation: () => ScreenOrientation
});
module.exports = __toCommonJS(index_native_exports);
var import_validateCallback = require("../validateCallback");
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneScreenOrientation");
  return hybrid;
}
function getOrientation() {
  return native().getOrientation().catch(import_nativeError.rethrowNativeError);
}
function lock(orientation) {
  return native().lock(orientation).catch(import_nativeError.rethrowNativeError);
}
function unlock() {
  return native().unlock().catch(import_nativeError.rethrowNativeError);
}
function addChangeListener(onChange) {
  (0, import_validateCallback.validateCallback)(onChange, "ScreenOrientation.addChangeListener requires a function");
  return native().addChangeListener(onChange);
}
var ScreenOrientation = Object.freeze({
  getOrientation,
  lock,
  unlock,
  addChangeListener
});
//# sourceMappingURL=index.native.js.map
